import React from 'react';
import { Input, Button, CheckboxTable, PaperClip, Select } from 'components';
import { UserService, ModeratorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { UserImage } from 'assets/img';
import { DownloadIcon } from 'assets/icons';

import PHONE_CODES from 'utils/phonecodes';
import { isValidPhoneNumber } from 'libphonenumber-js';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
}

class CreateUser extends React.Component<Props> {
  state = {
    form: {
      name: '',
      lastname: '',
      phone: '',
      phone_code: PHONE_CODES[0].value,
      document: '',
      document_type_id: Constants.DOCUMENT_TYPES.V,
      email: '',
      photo: '',
    },
    document_types: [],
    user: null,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await ModeratorService.admin.getDocumentTypes({
      user_id: this.props.item?.id,
    });
    this.setState(
      {
        document_types: res.document_types || [],
        user: res.user,
      },
      () => {
        if (this.props.item) {
          let reconstructedPhone = this.props.item?.phone || '';
          const savedPhonecodeId = this.props.item?.phonecode_id;

          if (savedPhonecodeId && res.phonecodes?.length > 0) {
            const operadora = res.phonecodes.find((p: any) => p.id === savedPhonecodeId);
            if (operadora) {
              const prefix = operadora.name.replace(/^0/, '');
              if (!reconstructedPhone.startsWith(prefix)) {
                reconstructedPhone = prefix + reconstructedPhone;
              }
            }
          }

          const resolvedPhoneCode = this.props.item?.phone_code
            ? PHONE_CODES.find(
                (p: any) =>
                  p.value === this.props.item.phone_code ||
                  p.callingCode === this.props.item.phone_code,
              )?.value || PHONE_CODES[0].value
            : PHONE_CODES[0].value;

          this.setState({
            form: {
              ...this.state.form,
              name: this.props.item?.name || '',
              email: this.props.item?.email || '',
              lastname: this.props.item?.lastname || '',
              document: this.props.item?.document || '',
              document_type_id: this.props.item?.document_type_id || Constants.DOCUMENT_TYPES.V,
              phone: reconstructedPhone,
              phone_code: resolvedPhoneCode,
            },
          });
        }
      },
    );
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (
      this.state.form.phone &&
      !isValidPhoneNumber(this.state.form.phone, this.state.form.phone_code as any)
    ) {
      Globals.showError('El número de teléfono no es válido para el país seleccionado');
      return;
    }

    try {
      if (this.props.item != null) {
        await UserService.admin.update({
          user_id: this.props.item?.id,
          ...this.state.form,
          password: '',
          hasFile: true,
          // @ts-ignore,
          photo: this.state.form.photo?.value || '',
        });
        Globals.showSuccess('Se ha modificado el cliente correctamente');
        this.props.onClose();
      } else {
        await UserService.admin.create({
          ...this.state.form,
          hasFile: true,
          // @ts-ignore,
          photo: this.state.form.photo?.value || '',
        });
        Globals.showSuccess('Se ha creado el cliente correctamente');
        this.props.onClose();
      }
    } catch (err: any) {
      Globals.showError(err.friendlyMessage);
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    const user: any = this.state.user;

    return (
      <div id='modal-create-user'>
        <form className='row' onSubmit={this.submit}>
          <div className='col-md-12'>
            <div className='container-inputs row'>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.name}
                  name='name'
                  label='Nombre'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.lastname}
                  name='lastname'
                  label='Apellido'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'>
                <p className='label'>C.I.</p>
                <div className='container-select'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    name='document_type_id'
                    onChange={this.change}
                    value={this.state.form.document_type_id}
                    options={this.state.document_types.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.document}
                    name='document'
                    maxLength={9}
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <p className='label'>Teléfono</p>
                <div className='container-select'>
                  <Select
                    color='white'
                    placeholder='Código'
                    name='phone_code'
                    style={{ width: 115 }}
                    onChange={this.change}
                    value={this.state.form.phone_code}
                    options={PHONE_CODES}
                  />
                  <Input
                    type='number'
                    color='white'
                    maxLength={15}
                    value={this.state.form.phone}
                    name='phone'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.email}
                  name='email'
                  label='Correo'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'></div>
            </div>
          </div>
          <div className='col-md-12 text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreateUser;
